const languages: string[] = ["cs_CZ", "da_DK", "de_DE", "de_AT", "en_US", "en_GB", "es_ES", "ca_ES", "eu_ES", "gl_ES", "fi_FI", "fr_FR", "hi_IN", "hu_HU", "it_IT", "nl_NL", "no_NO", "pt_PT", "pt_BR", "pl_PL", "ro_RO", "ru_RU", "sk_SK", "sv_SE", "tr_TR","el_GR", "vi_VN", "sw_KE", "ms_MY", "id_ID", "tl_PH"];

export default languages;
